import { useState, useEffect } from 'react';
import { WifiOff, Wifi, CloudOff, RefreshCw } from 'lucide-react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';

export function NetworkStatus() {
  const { isOnline, wasOffline, isSlowConnection } = useNetworkStatus();
  const [showStatus, setShowStatus] = useState(false);
  const [statusMessage, setStatusMessage] = useState<string>('');

  useEffect(() => {
    if (isOnline && wasOffline) {
      setStatusMessage('অনলাইনে ফিরে এসেছেন');
      setShowStatus(true);
      const timer = setTimeout(() => setShowStatus(false), 3000);
      return () => clearTimeout(timer);
    } else if (!isOnline) {
      setStatusMessage('অফলাইন মোড - ক্যাশ থেকে দেখানো হচ্ছে');
      setShowStatus(true);
    } else if (isSlowConnection) {
      setStatusMessage('ধীর সংযোগ সনাক্ত হয়েছে');
      setShowStatus(true);
      const timer = setTimeout(() => setShowStatus(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [isOnline, wasOffline, isSlowConnection]);

  if (!showStatus) return null;

  const getStatusColor = () => {
    if (!isOnline) return 'bg-amber-600 text-white';
    if (isSlowConnection) return 'bg-amber-500 text-amber-950';
    return 'bg-success text-success-foreground';
  };

  const getIcon = () => {
    if (!isOnline) return <CloudOff className="h-3.5 w-3.5" />;
    if (isSlowConnection) return <RefreshCw className="h-3.5 w-3.5 animate-spin" />;
    return <Wifi className="h-3.5 w-3.5" />;
  };

  return (
    <div
      className={`
        fixed top-0 left-0 right-0 z-[100]
        flex items-center justify-center gap-2 py-2 px-4
        text-xs font-medium transition-all duration-300
        pointer-events-none
        ${getStatusColor()}
      `}
      style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
    >
      {getIcon()}
      <span>{statusMessage}</span>
    </div>
  );
}
